// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { xScreen } from "@awc/XDL/Utilities";
import { orderStatusHeaderStyles } from "@insite/content-library/Widgets/OrderStatus/OrderStatusHeader";
import { css } from "styled-components";

orderStatusHeaderStyles.buttonsGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        display: flex;
        justify-content: flex-end;

        ${xScreen("lte", "sm")} {
            flex-direction: column;
            gap: 10px;
        }
    `,
};

orderStatusHeaderStyles.titleText = {
    variant: "h2",
    css: css`
        @media print {
            font-size: ${fontConfig.fontSize.link}px !important;
            line-height: ${fontConfig.fontSize.regular}px;
        }
    `,
};

orderStatusHeaderStyles.titleGridItem = {
    width: [12, 12, 6, 6, 6],
};

orderStatusHeaderStyles.shareEntityButtonStyles = {
    button: {
        variant: "primary",
        css: css`
            ${xScreen("lte", "sm")} {
                width: 100%;
                order: 2;
            }
        `,
    },
};

orderStatusHeaderStyles.printButton = {
    variant: "primary",
    css: css`
        margin-left: 10px;
        ${xScreen("lte", "sm")} {
            order: 1;
            width: 100%;
            margin-left: 0;
        }
    `,
};

orderStatusHeaderStyles.reorderButton = {
    variant: "tertiary",
    css: css`
        display: flex;
        align-items: center;
        margin-left: 10px;

        ${xScreen("lte", "sm")} {
            width: 100%;
            margin-left: 0;
        }
    `,
};

orderStatusHeaderStyles.spinner = {
    size: 22,
    css: css`
        margin: 8px;
        ${xScreen("lte", "sm")} {
            align-self: center;
        }
    `,
};

orderStatusHeaderStyles.container = {
    gap: 5,
    css: css`
        margin-top: 0;
    `,
};
